export const Count = ({
  amount,
  noun,
  plural,
}: {
  amount: number;
  noun: string;
  plural: string;
}) => (
  <>
    {amount.toLocaleString("en-us")} {amount === 1 ? noun : plural}
  </>
);
